// Formatting helpers shared by the candidate cards and the zoom modal.
import { coolGrey, positiveGreen, softAmber } from 'lib/css/colors';
import { BrandSkuMapperMfrToDpTier } from 'lib/enums/BrandSkuMapperMfrToDpEnums';

export const MISMATCH_SIGNAL_LABELS = { gtin: 'GTIN', mpn: 'MPN', brand_id: 'brand' };

export function tierColor(tier) {
  if (tier === BrandSkuMapperMfrToDpTier.HIGH) return positiveGreen;
  if (tier === BrandSkuMapperMfrToDpTier.LOW) return softAmber;
  return coolGrey;
}

export function pct(cal) {
  if (cal == null || Number.isNaN(Number(cal))) return '—';
  return `${(Number(cal) * 100).toFixed(1)}%`;
}

// A candidate DP's brand line: "brand · MPN xxx · manufacturer" (MPN segment only when present).
export function candBrandLine(vp = {}) {
  return [vp.brand || '—', vp.mpn ? `MPN ${vp.mpn}` : null, vp.manufacturer || '—']
    .filter(Boolean)
    .join(' · ');
}

// A candidate DP's identity line: "distributor · SKU xxx".
export function candVendorSkuLine(vp = {}) {
  return `${vp.vendor || '—'} · SKU ${vp.vendor_sku || '—'}`;
}
